// services
import { AuthenticationService } from './services/authentication.service';

// modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
// import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

// components
import { LoginComponent } from './components/login/login.component';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { ValidatorFormFieldDirective } from '../shared/directives/validator-form-field.directive';
import { RecoverPasswordComponent } from './components/recover-password/recover-password.component';
import { AccessTokenInterceptor } from './services/access-token.interceptor';
import { ChooseUnitModalComponent } from './components/choose-unit-modal/choose-unit-modal.component';
import { DataViewModule } from 'primeng/dataview';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PasswordModule } from 'primeng/password';
import { CardModule } from 'primeng/card';
import { SharedModule } from '../shared/shared.module';
@NgModule({
  declarations: [LoginComponent,RecoverPasswordComponent,ValidatorFormFieldDirective, ChooseUnitModalComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    InputTextModule,
    ButtonModule,
    RippleModule,
    DataViewModule,
    ProgressSpinnerModule,
    CardModule,
    PasswordModule,
    SharedModule
    // MatProgressSpinnerModule
  ],
  providers: [AuthenticationService, {
    provide: HTTP_INTERCEPTORS,
    useClass: AccessTokenInterceptor,
    multi: true
  },],
})
export class CoreModule {}
